import { useSelector, useDispatch } from "react-redux";
import { selectSquares, selectSquare } from "./TicTacToeSlice";

export interface SquareProps {
  square: number;
}

export function Square(props: SquareProps) {
  const value = useSelector(selectSquares)[props.square];
  const dispatch = useDispatch();

  return (
    <button
      data-test-id={`tic-tac-toe__square-button-${props.square}`}
      className="square"
      onClick={() => dispatch(selectSquare(props.square))}
    >
      {value}
    </button>
  );
}
